// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"d61dfb7789613c7007f5","293":"02103491c3a02be5be81","518":"667d2b5f7751080e1589","779":"56585ab1ab2c6a7c6aed"}[chunkId] + ".js";
};